import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SeemoreConfigurationService {
    constructor(private readonly http: HttpClient) {}

    public setSeemoreConfiguration(systemId: number, isEnabled: boolean): Observable<boolean> {
        return this.http
            .post<boolean>('/rest/pqm/systemSetup/setSeemoreConfiguration', isEnabled, {
                params: { systemId }
            })
            .pipe(
                catchError((err) => {
                    console.log('failed to set Seemore Configuration enablement ', err);
                    return throwError(err);
                })
            );
    }
}
